var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"active":_vm.$props.popupActive,"title":'Notes SEO : ' + _vm.$props.prospect_url},on:{"update:active":function($event){return _vm.$set(_vm.$props, "popupActive", $event)}}},[_c('div',{staticClass:"chart-container"},[_c('EChart',{key:_vm.chartDivKey,attrs:{"options":_vm.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }